module.exports = __webpack_public_path__ + "static/media/success-cart-curve-bottom.140839ba.svg";